import { ErrorCode, Fee, Security } from '@blk/wealth-web-endpoint';
import { WweErrorCode } from '@ddt-web/error-handler';
import { HoldingsUtil, ObjectUtil } from '@ddt-web/generic-utils';

import { WweFee } from '../objects/wwe-fee.model';
import { WweSecurity } from '../objects/wwe-security.model';

export const mapSecurityToWweSecurity = (security: Security) => {
	return ObjectUtil.cleanup({
		...HoldingsUtil.retrieveImportantSecurityIdentifiers(security),
		cins: security.cins,
		sedol: security.sedol,
		clientId: security.clientId,
		lastUpdatedTime: security.lastUpdatedTime,
		bpasRiskProxy: security.bpasRiskProxy,
		listingClassGlobalId: security.listingClassGlobalId,
		fundGlobalId: security.fundGlobalId,
		description: security.description,
		secType: security.secType,
		secGroup: security.secGroup,
		secDesc2: security.secDesc2,
		assetClass: security.assetClass,
		assetType: security.assetType,
		legalType: security.legalType,
		displayId: security.displayId,
		displayIdType: security.displayIdType,
		esg: security.esg,
		currency: security.currency,
		country: security.country,
		market: security.market,
		inceptionDate: security.inceptionDate,
		coupon: security.coupon,
		couponType: security.couponType,
		maturity: security.maturity,
		price: security.price,
		pricedAsPct: security.pricedAsPct,
		standardPerformances: security['standardPerformances'], // TODO libian: change once WWE ts lib gets updated
		analytics: security.analytics,
		breakdowns: security.breakdowns,
		clients: security.clients,
		lists: security.lists,
		ratings: security.ratings,
		issuers: security.issuers,
		funds: security.funds,
		valuations: security.valuations,
		identifiers: security.identifiers,
		derivatives: security.derivatives,
		fees: security.fees ? security.fees.map(mapFeeToWweFee) : [],
		morningstarCategory: security?.funds?.['morningstarCategory'],
		morningstarFundId: security?.funds?.['morningstarFundId'],
		request: security['request'] // TODO libian: change once WWE ts lib gets updated
	}) as WweSecurity;
};

export const mapFeeToWweFee = (fee: Fee) => {
	return {
		category: fee.category,
		subCategory: fee.subCategory,
		eventType: fee.eventType,
		amount: fee.amount,
		minimumPositionMarketValue: fee.minimumPositionMarketValue,
		maximumPositionMarketValue: fee.maximumPositionMarketValue,
		startYear: fee.startYear,
		endYear: fee.endYear,
		paymentMethod: fee.paymentMethod,
		percentMethod: fee.percentMethod
	} as WweFee;
};


export const mapErrorCodeToWweErrorCode = (errorCode: ErrorCode) => {
	return {
		code: errorCode.code,
		description: errorCode.description
	} as WweErrorCode;
};
